import { customersURL } from '.';
import { AxiosInstance } from 'axios';
import { createAuthenticatedApi } from './axios-client';

export type Customer = {
  id: string;
  name: string;
  email: string;
  phone: string;
  centerID: string;
  isDeleted: boolean;
};

export type CustomerWriteModel = Omit<Customer, 'id'>;

function getCustomerApi(): AxiosInstance {
  return createAuthenticatedApi(customersURL);
}

export async function createCustomer(
  customer: CustomerWriteModel,
): Promise<Customer> {
  const api = getCustomerApi();

  const res = await api.post('', customer);

  return res.data as Customer;
}
export async function updateCustomer(
  id: string,
  customer: CustomerWriteModel,
): Promise<Customer> {
  const api = getCustomerApi();

  const res = await api.put(`/${id}`, customer);

  return res.data as Customer;
}
export async function getAllCustomers(): Promise<Customer[]> {
  const api = getCustomerApi();

  const res = await api.get('');

  return res.data as Customer[];
}

export async function getCustomerByID(id: string): Promise<Customer> {
  const api = getCustomerApi();

  const res = await api.get(`/${id}`);

  return res.data as Customer;
}

export async function deleteCustomer(id: string): Promise<void> {
  const api = getCustomerApi();

  await api.delete(`/${id}`);
}
